import React from 'react';
import { Card, Col, Row } from 'react-bootstrap';

const PageWrapper = ({
  pageName,
  headerBtnTitle,
  onHeaderButtonClick,
  children,
  showFilterBtn,
  onFilterBtnClick,
  filterBtnTitle,
  showAddBtn,
}) => {
  return (
    <Row className="row-sm page-wrapper-print">
      <Col xl={12}>
        <Card className="page-card-print">
          <Card.Header className="pb-0 page-card-header-print">
            <div className="d-flex justify-content-between">
              <h4 className="card-title mg-b-0">{pageName}</h4>
              <span>
                {showFilterBtn ? (
                  <button type="button" className="btn btn-sm btn-dark me-2" onClick={onFilterBtnClick}>
                    {filterBtnTitle}
                  </button>
                ) : (
                  ''
                )}
                {showAddBtn ? (
                  <button type="button" className="btn btn-sm btn-dark float-end" onClick={onHeaderButtonClick}>
                    {headerBtnTitle}
                  </button>
                ) : (
                  ''
                )}
              </span>
            </div>
          </Card.Header>

          <Card.Body className="page-card-body-print">{children}</Card.Body>
        </Card>
      </Col>
    </Row>
  );
};

export default PageWrapper;
